import { jsxs as o, Fragment as m, jsx as e } from "react/jsx-runtime";
import { FormInputUrl as p } from "@systemeio/ui";
import { useState as u, useEffect as f } from "react";
import { CheckIcon as h } from "@systemeio/ui/icons";
import { ToolbarButton as n } from "../../components/content-controls/toolbar-button.mjs";
import { getToolbarIconClassName as c } from "../../constants/default-styles.mjs";
import k from "../../icons/download-icon.mjs";
import x from "../../icons/edit-icon.mjs";
import b from "../../icons/link-unset-icon.mjs";
function L({ href: r, unsetLink: t, setIsEditing: l }) {
  return /* @__PURE__ */ o(m, { children: [
    /* @__PURE__ */ e("div", { className: "w-[220px] truncate", children: /* @__PURE__ */ e("a", { href: r, target: "_blank", className: "text-brand-primary truncate px-3 underline", children: r }) }),
    /* @__PURE__ */ o("div", { className: "flex", children: [
      /* @__PURE__ */ e(n, { onClick: t, children: /* @__PURE__ */ e(b, { className: "main-transition-colors stroke-text-primary group-hover:stroke-red h-3.5 w-3.5" }) }),
      /* @__PURE__ */ e(n, { onClick: () => l(!0), children: /* @__PURE__ */ e(x, { className: c(!1) }) })
    ] })
  ] });
}
function j({
  initialValue: r,
  onSaveLink: t,
  openFileSelector: l,
  schemeOptions: d
}) {
  const [a, i] = u(r);
  f(() => {
    i(r);
  }, [r]);
  const s = a.length === 0;
  return /* @__PURE__ */ o(m, { children: [
    /* @__PURE__ */ e(
      p,
      {
        schemeOptions: d,
        className: "w-[250px]",
        value: a,
        placeholder: "example.com",
        onChange: i
      }
    ),
    /* @__PURE__ */ o("div", { className: "flex", children: [
      /* @__PURE__ */ e(n, { onClick: l, children: /* @__PURE__ */ e(k, { className: c(!1) }) }),
      /* @__PURE__ */ e(n, { type: "submit", onClick: () => t(a), disabled: s, children: /* @__PURE__ */ e(h, { className: c(s) }) })
    ] })
  ] });
}
export {
  j as LinkBubbleEdit,
  L as LinkBubbleView
};
